import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Alert,
  Typography
} from '@mui/material';
import { doc, setDoc } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { useTranslation } from "react-i18next";
import "../i18n";
import { getRoleLabels, getStoredTutorType } from '../utils/roleTerminology';

function TeacherQuizCodesDialog({
  open,
  onClose,
  teacherCode,
  studentCode,
  onChangeTeacherCode,
  onChangeStudentCode,
  groupId,
  onSaved
}) {
  const { t } = useTranslation();
  const role = getRoleLabels(t, getStoredTutorType());
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleSave = async () => {
    if (!teacherCode || !studentCode) {
      setError(t("Please enter both codes."));
      return;
    }

    setError('');
    try {
      setSaving(true);

      const groupRef = doc(db, 'groups', groupId);
      await setDoc(
        groupRef,
        {
          TeacherQuizCode: teacherCode.trim(),
          StudentQuizCode: studentCode.trim()
        },
        { merge: true }
      );

      if (onSaved) {
        onSaved(teacherCode.trim(), studentCode.trim());
      }
    } catch (e) {
      console.error('Failed saving quiz codes:', e);
      setError(t("An error occurred while saving the codes. Please try again."));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={saving ? undefined : onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          overflow: "hidden",
          boxShadow: "0 20px 60px rgba(15, 23, 42, 0.18)",
        },
      }}
    >
      <DialogTitle sx={{ textAlign: 'center', fontWeight: 800 }}>
        {t("Link quizzes section")}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 2, direction: 'rtl', textAlign: 'center' }}>
          <Typography variant="body1">
            {t("Enter the quiz codes provided by the administration to link this group with the Darssy Quizzes app.")}
          </Typography>

          <TextField
            label={t("Teacher quiz code")}
            value={teacherCode}
            onChange={(e) => onChangeTeacherCode(e.target.value)}
            fullWidth
          />

          <TextField
            label={role.isCoach ? t("Client quiz code") : t("Student quiz code")}
            value={studentCode}
            onChange={(e) => onChangeStudentCode(e.target.value)}
            fullWidth
          />

          {error && <Alert severity="error">{error}</Alert>}
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, pt: 1 }}>
        <Button variant="contained" fullWidth onClick={handleSave} disabled={saving}>
          {t("Save and continue")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default TeacherQuizCodesDialog;
